import { render, staticRenderFns } from "./sthi1.vue?vue&type=template&id=788995d0&scoped=true&"
import script from "./sthi1.js?vue&type=script&lang=js&"
export * from "./sthi1.js?vue&type=script&lang=js&"
import style0 from "./sthi1.css?vue&type=style&index=0&id=788995d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788995d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText})
